import { createContext } from 'react'

export const ChipsContext = createContext()
